var _g, _path, _path2, _circle, _path3, _path4, _ellipse, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoResults({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 94,
    viewBox: "0 0 110 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4081_27888)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    width: 94,
    height: 94,
    rx: 47,
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 15.5,
    r: 4.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 11,
    width: 48,
    height: 4,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 16,
    width: 31,
    height: 4,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 34.5,
    r: 4.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 30,
    width: 60,
    height: 4,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 35,
    width: 31,
    height: 4,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 53.5,
    r: 4.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 49,
    width: 63,
    height: 4,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 54,
    width: 31,
    height: 4,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 72.5,
    r: 4.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 68,
    width: 48,
    height: 4,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 73,
    width: 31,
    height: 4,
    rx: 2,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.2607 44.4043L51.573 47.1706L44 45.3839L44.6877 42.6176L52.2607 44.4043ZM109.107 44.737L101.374 45.673L101.014 42.8483L108.746 41.9114L109.107 44.737ZM55.7342 39.1062L53.8386 41.2729L47.9092 36.3473L49.8039 34.1816L55.7342 39.1062ZM106.175 35.3632L99.7096 39.5992L98.0794 37.2361L104.545 33L106.175 35.3632Z",
    fill: "url(#paint0_linear_4081_27888)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0963 73.1839C40.2685 71.4042 42.3026 70.4784 43.7578 71.5173L48.0248 74.5637C49.48 75.6027 49.2648 77.8273 47.6375 78.568L42.8656 80.74C41.2382 81.4807 39.4192 80.182 39.5914 78.4023L40.0963 73.1839Z",
    fill: "#9B9B9B"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 77,
    cy: 62,
    r: 19,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M94 56C92.5 70.5 78 65 73 79C73 79 81.0882 84.5 90.5 74.5C99.9118 64.5 94 56 94 56Z",
    fill: "url(#paint1_radial_4081_27888)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.385 84.6428L94.1563 75.4145C101.888 65.6875 100.392 51.4709 90.6645 43.7392C80.9375 36.0074 66.7209 37.7533 58.9892 47.2309C51.2574 56.958 53.0033 71.1745 62.4809 78.9063C70.7115 85.391 82.4339 85.391 90.6645 78.9063L99.8928 88.1346C100.89 89.1322 102.387 89.1322 103.385 88.1346C104.382 87.1369 104.382 85.6404 103.385 84.6428ZM76.6974 78.9063C66.9704 78.9063 59.2386 71.1745 59.2386 61.4474C59.2386 51.7204 66.9704 43.9886 76.6974 43.9886C86.4245 43.9886 94.1563 51.7204 94.1563 61.4474C94.1563 71.1745 86.4245 78.9063 76.6974 78.9063Z",
    fill: "black"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 88.0515,
    cy: 23.9271,
    rx: 3.55932,
    ry: 3.42708,
    fill: "#9B9B9B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4081_27888",
    x1: 78.5,
    y1: 33,
    x2: 78,
    y2: 47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BCB83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BCAA1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_4081_27888",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(50 -25 57.4367 121.385 72.5 81)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0716113,
    stopColor: "#FE560E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2979,
    stopColor: "#A9997E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5057,
    stopColor: "#6BC8CD"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4081_27888"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    width: 94,
    height: 94,
    rx: 47,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResults);
export default __webpack_public_path__ + "static/media/no_results.f5c567ee4a42dd022e17ba67791d1b6a.svg";
export { ForwardRef as ReactComponent };